import {
  EXAM_COURSE_LANGUAGE_TEXT,
  EXAM_COURSE_TYPE_TEXT,
} from '@exam-management/examination-course-details';
import { type ExamCourseLanguage, ExamCourseType, TagCategory } from '@exam-management/graphql';
import { EllipsisText, Label, StarRoundedIcon, Text, type GridColDef } from '@shared/components';

import { type ExamCourse } from '../../types';

interface ExamCourseListItem {
  id: string;
  examId: number;
  name: string;
  type: ExamCourseType;
  language: ExamCourseLanguage;
  tagEntities?: ExamCourse['tagEntities'];
}

export const columns: GridColDef<ExamCourseListItem>[] = [
  {
    field: 'examId',
    headerName: 'ExamID',
    sortable: false,
    width: 100,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    sortable: false,
    renderCell: ({ row }) => {
      return <EllipsisText variant='body1Semibold'>{row.name}</EllipsisText>;
    },
  },
  {
    field: 'type',
    headerName: 'Type',
    sortable: false,
    width: 100,
    renderCell: ({ row }) => {
      const { type } = row;
      return (
        <Label
          size='large'
          borderType='round'
          startIcon={
            type === ExamCourseType.Main ? (
              <StarRoundedIcon
                sx={{
                  color: (theme) => theme.palette.primary.main,
                  fontSize: 16,
                }}
              />
            ) : undefined
          }
          sx={(theme) => ({
            color: theme.palette.grey[700],
            borderColor: theme.palette.primary.light,
            backgroundColor: theme.palette.primary.lighter,
          })}
        >
          <Text variant='body2Semibold'>{EXAM_COURSE_TYPE_TEXT[type]}</Text>
        </Label>
      );
    },
  },
  {
    field: 'language',
    headerName: 'Language',
    sortable: false,
    width: 100,
    renderCell: ({ row }) => {
      return <Text>{EXAM_COURSE_LANGUAGE_TEXT[row.language]}</Text>;
    },
  },
  {
    field: 'totalQSet',
    headerName: 'QSet',
    sortable: false,
    width: 100,
  },
  {
    field: 'totalQConfig',
    headerName: 'QConfig',
    sortable: false,
    width: 100,
  },
  {
    field: 'group',
    headerName: 'Group',
    sortable: false,
    width: 120,
    renderCell: ({ row }) => {
      const group = row.tagEntities?.find(
        (tagEntity) => tagEntity.tag?.category === TagCategory.ExamCourseGroup,
      );
      const groupLabel = group ? group.tag?.name : '-';

      return <EllipsisText variant='body1Semibold'>{groupLabel}</EllipsisText>;
    },
  },
];
